<template>
  <ContainerCustomizationFunnel>
    <template #guidance-grades="{ product }">
      <ReviewPhotosGuidance
        v-if="isReviewPhotosGuidanceCategory(product.tracking.categoryId)"
        :is-pending-reviews-per-grade
        :reviews-per-grade
        :tracking-model="product.model"
        :category-id="product.tracking.categoryId"
      />
    </template>
    <template #step-end-grades="{ product }">
      <ReviewPhotosGuidanceCarousel
        v-if="isReviewPhotosGuidanceCategory(product.tracking.categoryId)"
        :is-pending-reviews-per-grade
        :reviews-per-grade
        :tracking-model="product.model"
        :category-id="product.tracking.categoryId"
      />
    </template>
    <template #guidance-card-grades="{ product }">
      <ReviewPhotosGuidanceLearnMore
        v-if="isReviewPhotosGuidanceCategory(product.tracking.categoryId)"
      />
    </template>
  </ContainerCustomizationFunnel>
</template>

<script setup lang="ts">
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

import ContainerCustomizationFunnel from '~/scopes/product-core/components/containers/ContainerCustomizationFunnel/ContainerCustomizationFunnel.vue'
import { useReviewsPerGrade } from '~/scopes/product-core/pages/ProductDetailPage/us/composables/useFetchReviewsPerGrade/useFetchReviewsPerGrade'

import { REVIEW_PHOTOS_GUIDANCE_CATEGORIES } from '../../presentationals/ReviewPhotosGuidance/ReviewPhotosGuidance.constants'
import ReviewPhotosGuidance from '../../presentationals/ReviewPhotosGuidance/ReviewPhotosGuidance.vue'
import ReviewPhotosGuidanceCarousel from '../../presentationals/ReviewPhotosGuidance/components/ReviewPhotosGuidanceCarousel/ReviewPhotosGuidanceCarousel.vue'
import ReviewPhotosGuidanceLearnMore from '../../presentationals/ReviewPhotosGuidance/components/ReviewPhotosGuidanceLearnMore/ReviewPhotosGuidanceLearnMore.vue'

const experiments = useExperiments()
const isReviewPhotosGuidanceEnabled =
  experiments['experiment.photosInReview'] === 'withReviewPhotosGuidance'

const { reviewsPerGrade, isPendingReviewsPerGrade } = useReviewsPerGrade()

function isReviewPhotosGuidanceCategory(categoryId: string) {
  return (
    isReviewPhotosGuidanceEnabled &&
    REVIEW_PHOTOS_GUIDANCE_CATEGORIES.includes(
      categoryId as (typeof REVIEW_PHOTOS_GUIDANCE_CATEGORIES)[number],
    )
  )
}
</script>
